<template>
  <div>
    <div v-if="currentStep === 'contact'" class="modal filter-modal promt-create-modal offer-modal accept-offer">
      <div class="overlay" @click="$parent.closeAcceptOfferModal"></div>
      <div class="wrapper">
        <div class="container">
          <div>
            <div class="form-wrapper">
              <div class="form-fields">
                <div class="bottom">
                  <div class="title small">{{ $t('Contact information') }}</div>
                  <label>
                    <input
                        type="text"
                        :placeholder="$t('Name')"
                        v-model="name"
                    />
                  </label>
                  <label>
                    <input
                        type="text"
                        :placeholder="$t('Surname')"
                        v-model="surname"
                    />
                  </label>
                  <label>
                    <input
                        type="email"
                        :placeholder="$t('E-mail address')"
                        v-model="email"
                    />
                  </label>
                  <label>
                    <input
                        type="tel"
                        :placeholder="$t('Phone')"
                        v-model="phone"
                    />
                  </label>
                  <label>
                    <select v-model="country">
                      <option value="" disabled selected>
                        {{ $t('Country') }}
                      </option>
                      <option
                          v-for="(item, i) in countryOptions"
                          :value="item"
                          :key="i"
                      >
                        {{ item.title }}
                      </option>
                    </select>
                  </label>
                  <label>
                    <input
                        type="text"
                        :placeholder="$t('City')"
                        v-model="city"
                    />
                  </label>
                  <label>
                    <input
                        type="text"
                        :placeholder="$t('Address')"
                        v-model="address"
                    />
                  </label>
                  <label>
                    <input
                        type="text"
                        :placeholder="$t('Post Code')"
                        v-model="postCode"
                    />
                  </label>
                </div>
                <transition name="slide">
                  <div v-if="error" class="error-desc desc red">
                    {{ error }}
                  </div>
                </transition>
                <div class="buttons">
                  <!-- <button
                    :class="[
                      'button blue',
                      { disabled: !contactFieldsAreFilled },
                    ]"
                    @click="proceedToPayment('card')"
                  >
                    <span>{{ $t("Card") }}</span>
                  </button> -->
                  <button
                      v-if="sepaEnabled"
                      :class="[
                      'button blue',
                      { disabled: !contactFieldsAreFilled },
                    ]"
                      :disabled="!contactFieldsAreFilled"
                      @click="proceedToPayment('sepa')"
                  >
                    <span>SEPA</span>
                  </button>
                  <button
                      v-if="cardEnabled"
                      :class="[
                      'button blue',
                      { disabled: !contactFieldsAreFilled },
                    ]"
                      :disabled="!contactFieldsAreFilled"
                      @click="handleCardPayment"
                  >
                    <span>{{ $t('Card') }}</span>
                  </button>
                  <button class="button" @click="$parent.closeAcceptOfferModal">
                    {{ $t('Back') }}
                  </button>
                </div>
                <transition name="slide">
                  <div
                      v-if="!sepaEnabled && !cardEnabled"
                      class="error-desc desc red"
                  >
                    {{ $t('Payouts are temporarily unavailable.') }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PaymentSepaModal
        v-if="currentStep === 'sepa'"
        :error="error"
        @confirm="handleSepaPayment"
        @back="currentStep = 'contact'"
        @close="$parent.closeAcceptOfferModal"
        @goToTerms="handleGoToTerms"
        @goToPrivacy="handleGoToPrivacy"
    />
  </div>
</template>

<script>
import PaymentSepaModal from "@/components/PaymentSepaModal.vue";

export default {
  name: 'AcceptOfferModal',
  props: [],
  components: {PaymentSepaModal},
  data: function () {
    return {
      name: '',
      iban: '',
      currentStep: "contact",
      error: "",
      surname: "",
      email: "",
      phone: "",
      country: "",
      city: "",
      address: "",
      postCode: "",
      countryOptions: [],
    }
  },
  mounted() {
    this.getCountries();
  },
  computed: {
    contactFieldsAreFilled() {
      return (
          this.surname &&
          this.email &&
          this.phone &&
          this.country &&
          this.city &&
          this.address &&
          this.postCode
      );
    },
    contactInfo() {
      return {
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phone,
        country: this.country,
        city: this.city,
        address: this.address,
        postCode: this.postCode,
      };
    },
    settingsPayload() {
      const settings = this.$parent && this.$parent.settings;
      return settings && typeof settings === "object" ? settings : {};
    },
    payoutMethods() {
      const methods = this.settingsPayload.payout_methods;
      return methods && typeof methods === "object" ? methods : {};
    },
    sepaEnabled() {
      return this.payoutMethods.sepa !== false;
    },
    cardEnabled() {
      return this.payoutMethods.card !== false;
    },
  },
  methods: {
    getCountries() {
      this.$http
          .get(process.env.VUE_APP_API + "countries")
          .then((res) => {
            this.countryOptions = res.data.payload;
          })
          .catch((res) => {
            if (res.response.status === 401) {
              this.$parent.openSignInModal();
            }
          });
    },
    proceedToPayment(type) {
      if (!this.contactFieldsAreFilled) {
        return;
      }

      this.error = "";

      if (type === 'card') {
        this.handleCardPayment();
      } else if (type === 'sepa' && !this.sepaEnabled) {
        this.error = this.$t("SEPA payouts are currently disabled.");
      } else {
        this.currentStep = type;
      }
    },
    handleCardPayment() {
      if (!this.cardEnabled) {
        this.error = this.$t("Card payouts are currently disabled.");
        return;
      }

      if (!this.contactFieldsAreFilled) {
        return;
      }

      const contactData = { ...this.contactInfo };
      if (contactData.country && typeof contactData.country === "object") {
        contactData.country = contactData.country?.title;
      }

      const data = {
        id: this.$parent.activeOffer.id,
        ...contactData,
        currency: 'EUR'
      };

      this.$http
          .post(process.env.VUE_APP_API + "offer/withdraw/card", data)
          .then((res) => {
            if (res.data && res.data.redirect_url) {
              window.location.href = res.data.redirect_url;
            } else {
              // Fallback if no redirect URL is provided
              this.$parent.closeAcceptOfferModal();
              this.$parent.closeOfferModal();
              this.$parent.openDealModal();
              this.$parent.getCreatedHistory();
            }
          })
          .catch((res) => {
            if (res.response && res.response.data && res.response.data.errors) {
              const firstErrors = {};
              for (const key in res.response.data.errors) {
                if (
                    res.response.data.errors.hasOwnProperty(key) &&
                    Array.isArray(res.response.data.errors[key]) &&
                    res.response.data.errors[key].length > 0
                ) {
                  firstErrors[key] = res.response.data.errors[key][0];
                  this.error = firstErrors[key];
                }
              }
            } else {
              this.error = (res.response && res.response.data && res.response.data.message)
                  ? res.response.data.message
                  : this.$t("Could not process card payout request.");
            }
          });
    },
    handleSepaPayment(paymentData) {
      if (!this.sepaEnabled) {
        this.error = this.$t("SEPA payouts are currently disabled.");
        return;
      }

      const contactData = { ...this.contactInfo };

      console.log('handleSepaPayment contactData: ', contactData);

      if (contactData.country && typeof contactData.country === "object") {
        contactData.country = contactData.country?.title;
      }

      // Map paymentData: split full_name and rename iban
      let first_name = "";
      let last_name = "";
      if (paymentData && paymentData.full_name) {
        const parts = String(paymentData.full_name).trim().split(/\s+/);
        first_name = parts.shift() || "";
        last_name = parts.join(" ");
      }

      if (!first_name || !last_name) {
        this.error = this.$t("Please enter your full name (at least two words)");
        return;
      }

      const mappedPayment = {
        account_number: paymentData?.iban || "",
        first_name,
        last_name,
      };

      const data = {
        id: this.$parent.activeOffer.id,
        ...contactData,
        ...mappedPayment,
      };

      this.$http
          .post(process.env.VUE_APP_API + "offer/request-payout/sepa-manual", data)
          .then(() => {
            this.$parent.closeAcceptOfferModal();
            this.$parent.closeOfferModal();
            this.$parent.openDealModal();
            this.$parent.getCreatedHistory();
          })
          .catch((res) => {
            if (res.response && res.response.data && res.response.data.errors) {
              const firstErrors = {};
              for (const key in res.response.data.errors) {
                if (
                    res.response.data.errors.hasOwnProperty(key) &&
                    Array.isArray(res.response.data.errors[key]) &&
                    res.response.data.errors[key].length > 0
                ) {
                  firstErrors[key] = res.response.data.errors[key][0];
                  this.error = firstErrors[key];
                }
              }
            } else {
              this.error = (res.response && res.response.data && res.response.data.message)
                  ? res.response.data.message
                  : this.$t("Could not process SEPA payout request.");
            }
          });
    },
    confirm() {
      let data = {
        'id': this.$parent.activeOffer,
        'iban': this.iban,
        'full_name': this.name
      }
      this.$http.post(process.env.VUE_APP_API + 'offer/approve', data)
          .then(() => {
            this.$parent.closeAcceptOfferModal();
            this.$parent.closeOfferModal();
            this.$parent.openDealModal();
            this.$parent.getCreatedHistory();
          })
          .catch((res) => {
            if (res.response.data.errors) {
              const firstErrors = {};
              for (const key in res.response.data.errors) {
                if (res.response.data.errors.hasOwnProperty(key) && Array.isArray(res.response.data.errors[key]) && res.response.data.errors[key].length > 0) {
                  firstErrors[key] = res.response.data.errors[key][0];
                  this.$emit('setError', firstErrors[key]);
                }
              }
            } else {
              this.$emit('setError', res.response.data.message);
            }
          })
    },
    handleGoToTerms() {
      this.$parent.closeOfferModal();
      this.$parent.closeAcceptOfferModal();
      this.$parent.goToPage("terms");
    },
    handleGoToPrivacy() {
      this.$parent.closeOfferModal();
      this.$parent.closeAcceptOfferModal();
      this.$parent.goToPage("privacy");
    },
  }
}
</script>
